module.exports = __webpack_public_path__ + "img/icon-type-image.ab2ec1bc.svg";